import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import useAuth from "../../hooks/useAuth";
import { ThreeCircles } from "react-loader-spinner";
import { useGetAllTeamsQuery } from "../../redux/features/teams/teamsApi";
import { useCreateProjectMutation } from "../../redux/features/projects/projectsApi";

function ProjectForm({ handleModal, modalRef, projectState }) {
  const [projectDescription, setProjectDescription] = useState("");
  const [team, setTeam] = useState("Select a team");
  const [selectedTeam, setSelectedTeam] = useState({});
  const [error, setError] = useState(null);
  const { user } = useAuth();
  const { data: teams } = useGetAllTeamsQuery({ all: "all" });
  const [createProject, { isLoading }] = useCreateProjectMutation();

  useEffect(() => {
    const convertedString = team.toString();
    const filteredTeam = teams?.filter(
      (team) => team.teamName === convertedString
    );
    setSelectedTeam(filteredTeam?.[0]);
  }, [team]);

  const formReset = () => {
    setError(null);
    setProjectDescription("");
    setTeam("Select a team");
  };

  const changeTeam = (e) => {
    setTeam(e.target.value);
  };

  const handleCreateProject = async (e) => {
    e.preventDefault();
    if (
      !error &&
      team !== "Select a team" &&
      team !== "" &&
      projectDescription
    ) {
      formReset();
      try {
        await createProject({
          projectDescription,
          projectCreator: user,
          team: selectedTeam,
          timeStamp: new Date().getTime(),
          projectState,
        }).unwrap();
        toast.success("Project has been created successfully", {
          autoClose: 2000,
        });
      } catch (error) {
        setError(error);
      }
    }
    if (team === "Select a team" && team === "" && !projectDescription) {
      setError("Please fill all the field");
    }
  };

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  return (
    <>
      <h1 className="mt-20 mb-8 text-3xl font-extrabold text-violet-600">
        Create a project
      </h1>
      <form className="flex flex-col gap-[12px]">
        <div>
          <textarea
            id="team-description"
            cols={50}
            rows={4}
            name="team-description"
            type="text"
            value={projectDescription}
            required
            className=" relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
            placeholder="Project Description"
            onChange={(e) => setProjectDescription(e.target.value)}
          />
        </div>

        <select
          id="teams"
          className="relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm "
          name="teams"
          value={team}
          onChange={changeTeam}
        >
          <option value={"Select a team"}>Select a team</option>
          {teams?.map((team) => (
            <option key={team.id} value={team.teamName}>
              {team.teamName}
            </option>
          ))}
        </select>

        <div className="relative flex justify-between items-center gap-4">
          <button
            disabled={
              team === "Select a team" ||
              team === "" ||
              projectDescription.length === 0 ||
              error
            }
            className={` ${
              isLoading
                ? " bg - black / 25"
                : " bg-violet-600 hover:bg-violet-700 "
            }    disabled:bg-gray-200 disabled:text-gray-400 disabled:scale-100 disabled:cursor-not-allowed w-1/2 px-3 py-2 rounded-md font-semibold text-violet-200 active:scale-[97%] ease-linear duration-75 `}
            onClick={handleCreateProject}
          >
            Create
          </button>
          <div className="absolute top-[50%] -translate-y-[50%] -translate-x-[25%] left-[21.5%] ">
            <ThreeCircles
              height="30"
              width="30"
              color="#4C51BF"
              wrapperStyle={{}}
              wrapperclassName=""
              visible={isLoading}
              ariaLabel="three-circles-rotating"
              outerCircleColor=""
              innerCircleColor=""
              middleCircleColor=""
            />
          </div>

          <button
            className="w-1/2 bg-red-600 hover:bg-red-700 px-3 py-2 rounded-md font-semibold text-red-200 active:scale-[97%] ease-linear duration-75"
            onClick={(e) => {
              e.preventDefault();
              modalRef?.current?.classList.add("animate__zoomOut");
              modalRef?.current?.addEventListener("animationend", (event) => {
                handleModal();
              });
            }}
          >
            Cancel
          </button>
        </div>
      </form>
    </>
  );
}

export default ProjectForm;
